import RedirectTo from "@/components/redirect";
import {oldDomain} from "@/constants/config";
import {URLS} from "@/lib/urls";


const oldRoutePrefixes = ['t', 'm', 'a', 'static', 'files', 'certificate', 'cms', 'lottery', 'r', 'crm', 'n', 'hook', 'pay', 'support'];

const generatedOldRoutes = oldRoutePrefixes.map((prefix) => ({
    path: `/${prefix}/*`,
    element: <RedirectTo url={oldDomain(prefix)}/>,
}));


const manualOldRoutes = [
    {
        path: '/s/*',
        element: <RedirectTo url={URLS.student.dashboard}/>,
    },
    {
        path: '/enter/*',
        element: <RedirectTo url={URLS.auth.login}/>,
    },
];

export const OldRoute = [
    ...generatedOldRoutes,
    ...manualOldRoutes,
];
